"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var WrapperPropertyArrayItemDirect = /** @class */ (function () {
    // private _dest: any;
    // private _schema: any;
    // private _options: IOptions;
    // private _parent: any;
    function WrapperPropertyArrayItemDirect(dest, parent, key, schema, options) {
        this.$key = key;
        this.$item = new WrappedPropertyCtor_1.default[schema.type](dest, parent, key, schema, options);
        // this._dest = dest;
        // this._parent = parent;
        // this._schema = schema;
        // this._options = options;
    }
    WrapperPropertyArrayItemDirect.prototype.$clearCache = function () {
        this.$item.$destroy();
    };
    /**
     * ustawienie $dirty na false ale tylko wtedy gdy jest pobrane
     */
    WrapperPropertyArrayItemDirect.prototype.$reset = function () {
        this.$item.$reset();
    };
    /**
     *
     */
    WrapperPropertyArrayItemDirect.prototype.$dirtyList = function (result) {
        this.$item.$dirtyList(result);
        return result;
    };
    WrapperPropertyArrayItemDirect.prototype.$destroy = function () {
        this.$clearCache();
    };
    WrapperPropertyArrayItemDirect.prototype.$setKey = function (newKey) {
        this.$key = newKey;
        this.$item.$key = newKey;
    };
    return WrapperPropertyArrayItemDirect;
}());
exports.WrapperPropertyArrayItemDirect = WrapperPropertyArrayItemDirect;
//# sourceMappingURL=WrappedPropertyArrayItemDirect.js.map